
import { Link } from "react-router-dom";
import Subscribe from "./Subscribe";
import solutions from "@/data/solutionsData";
import { Linkedin } from "lucide-react";

const Footer = () => {
  const services = [
    { name: "IT Infrastructure", slug: "it-infrastructure" },
    { name: "Software Development", slug: "software-development" },
    { name: "Cyber Security", slug: "cyber-security" },
    { name: "Cloud Services", slug: "cloud-services" },
    { name: "ERP Solutions", slug: "erp-solutions" }
  ];

  // Get the first 5 solutions from our data
  const footerSolutions = solutions.slice(0, 5).map(sol => ({
    name: sol.title,
    slug: sol.slug
  }));

  return (
    <footer className="bg-gradient-to-b from-purple-900 to-indigo-900 text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4 text-purple-200">About Us</h3>
            <p className="text-purple-100 mb-4">
              Your trusted partner for innovative IT solutions and services.
            </p>
            <Subscribe className="mb-4" />
            <div className="flex items-center mt-4">
              <a href="https://www.linkedin.com/company/ssl-solution" target="_blank" rel="noopener noreferrer" className="text-purple-100 hover:text-white transition-colors">
                <Linkedin className="h-6 w-6" />
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4 text-purple-200">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-purple-100 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-purple-100 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/services" className="text-purple-100 hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/solutions" className="text-purple-100 hover:text-white transition-colors">Solutions</Link></li>
              <li><Link to="/blog" className="text-purple-100 hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="text-purple-100 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4 text-purple-200">Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.slug}>
                  <Link 
                    to={`/services/${service.slug}`} 
                    className="text-purple-100 hover:text-white transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4 text-purple-200">Solutions</h3>
            <ul className="space-y-2">
              {footerSolutions.map((solution) => (
                <li key={solution.slug}>
                  <Link 
                    to={`/solutions/${solution.slug}`} 
                    className="text-purple-100 hover:text-white transition-colors"
                  >
                    {solution.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-purple-800 mt-8 pt-8 text-center text-purple-200">
          <p>&copy; 2024 SSL Solution. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
